export const CREATE_THEME = "CREATE_THEME";
export const RETRIEVE_THEMES = "RETRIEVE_THEMES";
export const UPDATE_THEME = "UPDATE_THEME";
export const DELETE_THEME = "DELETE_THEME";
export const DELETE_ALL_THEMES = "DELETE_ALL_THEMES";

